<template lang="pug">
  .date-picker
    v-menu(
      v-model="menu"
      min-width="290px"
      offset-y
      transition="scale-transition"
      :close-on-content-click="false"
    )
      template(v-slot:activator="{ on }")
        input-text(
          v-model.lazy="dateFormatted"
          mask="##/##/####"
          :input-key="inputKey"
          :label="label"
          prepend-icon="mdi-calendar-blank"
          :rules="rules"
          @icon-click="menu = true"
          :required="required"
        )
      v-date-picker(
        v-model="datePicker"
        no-title
        locale="pt-BR"
        @input="menu = false"
      )
</template>

<script>
import InputText from 'Support/components/inputs/InputText.vue';
import Moment from 'moment';

export default {
  name: 'DatePicker',
  components: {
    InputText,
  },
  props: {
    inputKey: {
      type: String,
      default: '',
    },
    value: {
      type: [Date, String],
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: Array,
      default() {
        return [];
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      date: '',
    };
  },
  computed: {
    dateFormatted: {
      get() {
        if (this.value) {
          return this.formatDateToBr(this.value);
        }
        return '';
      },
      set(value) {
        if (value.length === 8) {
          const formatedDate = this.dateTransform(value);

          if (this.formatDateToBr(formatedDate) !== this.date) {
            this.datePicker = formatedDate;
            this.handleDate(formatedDate);
          }
        }
      },
    },
    datePicker: {
      get() {
        const regex = /^\d{4}-\d{2}-\d{2}$/m;
        if (regex.exec(this.value) === null) {
          return null;
        }
        return this.value;
      },
      set(value) {
        if (this.formatDateToBr(value) !== this.date) {
          this.handleDate(value);
          this.$emit('input', this.transformDateToNumber(value));
        }
      },
    },
  },
  methods: {
    handleDate(date) {
      this.date = this.formatDateToBr(date);
    },
    formatDateToBr(date) {
      return Moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    fomatDate(date) {
      return Moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    dateTransform(value) {
      return value.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1');
    },
    transformDateToNumber(value) {
      return value.replace(/(\d{4})(\d{2})(\d{2})/, '$3$2$1');
    },
  },
};
</script>
